import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: false,
  name: 'addressFormatter'
})
export class AddressFormatterPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }
}
